import React, { useState } from "react";

import {
    Text,
    View
} from "react-native";
import NavBarButton from "./NavBarButton";
import { IcClose, IcFilter } from "../../utils/Icons";
import AppTheme from "../../utils/Theme";
import Modal from "../../../specific/components/Modal/Modal";
import UserLevelSelection from "../Filters/UserLevelSelection";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";

interface NavBarProps {
    showLevelFilter?: boolean;
    showDismissButton?: boolean;
    componentId?: string;
}

const NavBar = (props: NavBarProps) => {

    const appTheme: AppTheme = new AppTheme();

    const { showDismissButton = false, showLevelFilter = true, componentId = "" } = props;

    const [showLevelSelection, setShowLevelSelection] = useState<boolean>(false);

    const renderDismissButton = () => {
        if (showDismissButton === true) {
            return <NavBarButton icon={IcClose} action={() => Navigation.dismissModalInView({ componentId })} />
        }
        return <View />
    }

    const renderLevelFitlerButton = () => {
        if (showLevelFilter === true) {
            return <NavBarButton icon={IcFilter} action={() => setShowLevelSelection(true)} />
        }
        return <View />
    }

    return <View style={{ width: appTheme.getFullAppWidth(), flexDirection: "row", justifyContent: "space-between", position: "absolute", top: 0, left: 0, paddingHorizontal: 10, paddingTop: appTheme.topInsets + 10, paddingBottom: 10 }}>
        <View />
        <View>
            {renderLevelFitlerButton()}
            {renderDismissButton()}
        </View>
        <UserLevelSelection
            visible={showLevelSelection}
            style={{ flex: 1, justifyContent: "flex-end" }}
            backgroundColor={appTheme.schoolColor}
            toggleFilters={() => setShowLevelSelection(false)} />
    </View>
}

export default NavBar;